import React from 'react';
import { injectIntl } from 'react-intl';
import TextField from '@material-ui/core/TextField';

// Mirrors the DB constraint: tournament_award.tournament_name is VARCHAR(9).
const MAX_LENGTH = 9;

/**
 * Dedicated input for the award's tournament name.
 *
 * Unlike the generic Text input (which only surfaces errors once the field is
 * `touched`/blurred), this shows the length state live: a `current/max` counter while
 * within bounds, and the error as soon as the limit is exceeded — so the user gets
 * feedback while typing, not only when leaving the field.
 */
function TournamentNameInput({
  input: { name, value, onChange, ...inputEvents },
  intl: { formatMessage: f, messages: m },
}) {
  const current = value || '';
  const tooLong = current.length > MAX_LENGTH;
  const label = f({ id: `field_${name}` });

  return (
    <TextField
      label={label}
      error={tooLong}
      helperText={tooLong ? m.tournamentAward_nameTooLong : `${current.length}/${MAX_LENGTH}`}
      name={name}
      value={current}
      {...inputEvents}
      onChange={event => onChange(event.target.value || '')}
      fullWidth
    />
  );
}

export default injectIntl(TournamentNameInput);
